module.exports = __webpack_public_path__ + "img/product.d57d34b9.png";